import Instance from '../../../../Axios';

const DashboardIdadesObras = () => async (dispatch) => {
  await Instance()
    .get(`/dashboard/grObrasIdade`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: 'GET_DASHBOARD_IDADES_OBRAS', payload: data.yData });

      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      if (err.response) {
        if (err.response.status === 403) {
          // dispatch(ShowNotification(warningMessage));
        } else {
          // dispatch(ShowNotification(errorMessage));
        }
      }
    });
};

export default DashboardIdadesObras;
